import React from 'react';
import { m } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { scrollToId } from '../../utils/scroll';
import { transformationRows, transformationFooterStats } from '../../data/transformation';
export function Transformation() {
  return <section className="bg-gradient-to-b from-bg-secondary to-white py-14 sm:py-16" data-id="element-221" data-mp="2fgnn96ycy0nr">
      <div className="mx-auto max-w-4xl px-6 text-center sm:px-8" data-id="element-222" data-mp="2firsbs7zt5pm">
        <SectionTag icon="⚡" data-id="element-223" data-mp="2bgd9v988k7yv">La transformación</SectionTag>
        <h2 className="mt-5 font-heading text-[28px] font-bold uppercase text-marino sm:text-[36px]" data-id="element-224" data-mp="26o3hznnk8xty">
          Tus domingos no deberían terminar así...
        </h2>

        <div className="mt-6 rounded-2xl border-l-4 border-naranja bg-naranja-pale px-6 py-5 text-left" data-id="element-225" data-mp="21n63pm5o8nxq">
          <p className="text-base font-medium text-gris-texto" data-id="element-226" data-mp="2z6hb59xybvmp">
            Un domingo por la noche, buscando ejercicios sueltos en YouTube que no sabes si van a funcionar
            el martes con tus chavales.
          </p>
        </div>

        <div className="mt-4 rounded-2xl border-l-4 border-azul bg-azul-light px-6 py-5 text-left" data-id="element-227" data-mp="1a7j1imngh0f6">
          <p className="font-heading text-lg font-semibold text-marino" data-id="element-228" data-mp="wgnyvs3jvfk1">Recupera tus domingos</p>
        </div>
      </div>

      <div className="mx-auto mt-10 grid max-w-4xl gap-5 px-6 sm:grid-cols-2 sm:px-8" data-id="element-229" data-mp="10g53kjb5k8o5">
        {transformationRows.map((row, i) => <m.div key={row.title} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.08
      }} className="relative rounded-2xl border border-gris-claro bg-white p-6 shadow-leve" data-id="element-230" data-mp="mk1f76mymujl" data-mpi={i}>
            <span className="absolute right-5 top-5 font-heading text-sm font-semibold text-azul" data-id="element-231" data-mp="27urokm33uhja">{row.n}</span>
            <p className="pr-10 font-heading text-lg font-bold text-marino" data-id="element-232" data-mp="2bvbp7zmw03a6">{row.title}</p>
            <div className="mt-4 space-y-3" data-id="element-233" data-mp="3kumjvg6ayp61">
              <div className="flex items-start gap-2 rounded-lg bg-rojo-light p-4" data-id="element-234" data-mp="3kr74ec8pve43">
                <XIcon size={18} className="mt-0.5 flex-shrink-0 text-rojo" data-id="element-235" data-mp="3ft5m3tj47ito" />
                <p className="text-sm leading-relaxed text-gris-texto" data-id="element-236" data-mp="3btofuxvv6hng">{row.before}</p>
              </div>
              <div className="flex items-start gap-2 rounded-lg bg-verde-light p-4" data-id="element-237" data-mp="36vd4ujtu213n">
                <CheckIcon size={18} className="mt-0.5 flex-shrink-0 text-verde" data-id="element-238" data-mp="7ddipadph974" />
                <p className="text-sm font-medium leading-relaxed text-verde" data-id="element-239" data-mp="3ctnwdgluho5">{row.after}</p>
              </div>
            </div>
          </m.div>)}
      </div>

      <div className="mt-10 flex flex-col items-center gap-6 px-6 text-center sm:px-8" data-id="element-240" data-mp="3pso4w6nagyk5">
        <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-241" data-mp="3pqtsjgq32ero">Quiero dejar de improvisar</PrimaryButton>

        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-3" data-id="element-242" data-mp="mbxsna145pa0">
          {transformationFooterStats.map((stat, i) => <React.Fragment key={stat.label} data-id="element-243" data-mp="to401k50aqrw" data-mpi={i}>
              {i > 0 && <span className="hidden text-gris-claro sm:inline" data-id="element-244" data-mp="ym5nsiddne9p">|</span>}
              <span className="font-heading text-base font-semibold text-azul" data-id="element-245" data-mp="yo9mmlwf5n34">
                {stat.value} <span className="font-normal text-gris-texto" data-id="element-246" data-mp="13jyqv2jdvs5r">{stat.label}</span>
              </span>
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}